var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRollover = function SvgRollover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 2.44775,
    y: 3,
    width: 24.7164,
    height: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#FF6825",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2167 7.56146C16.3239 7.16136 16.7352 6.92392 17.1353 7.03113C21.5364 8.2104 24.1482 12.7342 22.9689 17.1353C21.7897 21.5364 17.2659 24.1482 12.8648 22.9689C8.46368 21.7896 5.85188 17.2659 7.03115 12.8648C7.13835 12.4647 7.5496 12.2272 7.9497 12.3344C8.3498 12.4416 8.58724 12.8529 8.48003 13.253C7.51518 16.8539 9.65211 20.5552 13.253 21.52C16.8539 22.4849 20.5552 20.3479 21.52 16.747C22.4849 13.1461 20.348 9.44487 16.7471 8.48002C16.347 8.37281 16.1095 7.96156 16.2167 7.56146ZM10.4809 7.61192C10.7021 7.47528 10.9783 7.46296 11.2108 7.57936C13.4424 8.69662 15.0709 10.8446 15.4699 13.4006L16.2478 12.4429C16.509 12.1214 16.9813 12.0725 17.3028 12.3336C17.6243 12.5947 17.6733 13.0671 17.4121 13.3886L15.5747 15.6509C15.3426 15.9366 14.9376 16.0117 14.6185 15.8282L11.9711 14.3053C11.6121 14.0987 11.4884 13.6403 11.695 13.2812C11.9015 12.9222 12.36 12.7985 12.719 13.0051L14.0042 13.7443C13.7125 11.6333 12.3872 9.85139 10.553 8.92753C10.2999 8.80703 10.125 8.54894 10.125 8.25001C10.125 7.99 10.2597 7.74855 10.4809 7.61192Z",
    fill: "#FF6825"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRollover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rollover.da4b6851.svg";